export enum treasuryRedeemRuleFormFields {
  portfolioId = 'portfolioId',
  amount = 'amount',
  frequency = 'frequency',
  dayOfMonth = 'dayOfMonth',
  monthOfYear = 'monthOfYear',
  insufficientFundsAction = 'insufficientFundsAction',
}
